<router-outlet *ngIf="canUseLocalStorage; else noLocalStorageAccessError"></router-outlet>

<ng-template #noLocalStorageAccessError>
  <!-- display: block -->
  <div class="alert alert-danger m-0" role="alert">
    <ng-container i18n="Third-party cookie error message (part 1)"
      >Your browser’s security settings prevent the online booking widget from working.</ng-container
    >

    <!-- This interpolated space below to prevents the sentences from sticking to one another. -->
    {{ ' ' }}

    <ng-container i18n="Third-party cookie error message (part 2)"
      >Please ensure that you allow third-party cookies.</ng-container
    >
  </div>
</ng-template>
